import { NavLink } from 'react-router-dom'
import { Home, ShoppingBag, Search, Tag, User } from 'lucide-react'
import { useCartStore } from '../../store/index.js'

const navItems = [
  { to: '/',           icon: Home,        label: 'Home',   exact: true },
  { to: '/shop',       icon: ShoppingBag, label: 'Shop' },
  { to: '/search',     icon: Search,      label: 'Search' },
  { to: '/promotions', icon: Tag,         label: 'Deals' },
  { to: '/account',    icon: User,        label: 'Account' },
]

export default function BottomNav() {
  const count = useCartStore(s => s.count)

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-surface-card border-t border-surface-border bottom-nav">
      <div className="flex items-center justify-around">
        {navItems.map(({ to, icon: Icon, label, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 py-2 px-3 min-w-[60px] relative transition-all duration-150 ${
                isActive ? 'text-primary' : 'text-gray-500'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className={`relative p-1.5 rounded-xl transition-all duration-150 ${isActive ? 'bg-primary/10' : ''}`}>
                  <Icon size={22} strokeWidth={isActive ? 2.5 : 1.8} />
                  {label === 'Shop' && count > 0 && (
                    <span className="absolute -top-1 -right-1 w-4 h-4 bg-primary rounded-full flex items-center justify-center text-white text-[10px] font-bold font-display">
                      {count > 9 ? '9+' : count}
                    </span>
                  )}
                </div>
                <span className={`text-[10px] font-display font-medium ${isActive ? 'text-primary' : 'text-gray-500'}`}>
                  {label}
                </span>
                {isActive && (
                  <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-primary rounded-full" />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
